
<mat-form-field>
    <mat-label>Templates</mat-label>
    <mat-select [(ngModel)]="template">
        <mat-option value="invoice.template.html">Invoice Email</mat-option>
        <mat-option value="receipt.template.html">Invoice Receipt</mat-option>
        <mat-option value="sms-review-request.template.html">SMS Review Request</mat-option>
        <mat-option value="sms-review-request-aged.template.html">SMS Review Request (Aged)</mat-option>
        <mat-option value="sms-repair-ready.template.html">SMS Repair Ready</mat-option>
    </mat-select>
</mat-form-field>

<button mat-raised-button (click)="renderTemplate()">Render Template</button>



<ng-container *ngIf="isHTML">
    <div [innerHtml]="renderedTemplate | byPassSecurity"></div>
</ng-container>

<ng-container *ngIf="!isHTML">
    <pre>{{renderedTemplate}}</pre>
</ng-container>
